export const OpensourceUsagePage = () => {
	return <iframe src="html/opensource-en.html" title="OSS Notice" style={{ width: '100%', minHeight: '100vh' }} />;
};
